<script lang="ts">
  import { Col, Row} from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import { Marketing } from "../../../Data/Chart/Widget/ChartPage/Chart";
  import { chart } from "svelte-apexcharts";
  import { MarketingExpenses } from "../../../utils/Constant/Constant";
</script>

<Col xl="7">
  <Card
    cardProps="o-hidden"
    cardHeaderprops="pb-0"
    headerTitle={MarketingExpenses}
  >
    <div class="bar-chart-widget" slot="contentbody">
      <div class="bottom-content">
        <Row>
          <Col>
            <div id="chart-widget4">
              <div use:chart={Marketing} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </Card>
</Col>
